export const checkAuth = () => {
    return fetch('http://localhost:500/auth/protected', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include'
    })
    .then(response => {
        if (!response.ok) {
            return { status: false };
        }

        return response.json();
    })
    .catch(error => {
        console.log('Auth check failed:', error);
        return { status: false };
    });
}
